/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { Divider, ListItem as MaterialListItem, GridList, Subheader, GridTile } from 'material-ui'
import { ListItem } from 'generic/list'
import AlertModal from 'generic/dialog/AlertModal'

import * as constants from 'constants/Prestation'

const windowHeight = window.innerHeight

class ValidationInformationPanel extends React.Component {
  constructor (props) {
    super(props)

    autoBind(this)

    this.state = {
      prestation: props.prestation,
      showDocument: false,
      document: undefined
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.prestation !== prevProps.prestation) {
      this.setState({
        prestation: this.props.prestation
      })
    }
  }

  handleDocumentDialogConfirm () {
    this.setState({
      showDocument: false
    })
  }

  handleDocumentModal (event) {
    this.setState({
      showDocument: true,
      document: event.target.src
    })
  }

  render () {
    return (
      <React.Fragment>
        <Divider/>

        <MaterialListItem
          primaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_LABEL)}
          initiallyOpen={false}
          primaryTogglesNestedList={true}
          nestedItems={[
            <div
              key={1}
              style={styles.nestedItem}
              className='row'
            >
              <div className="col-md-6 col-xs-12">
                <ListItem
                  disabled={true}
                  primaryText={
                    this.state.prestation.happened
                      ? this.props.intl.formatMessage(constants.messages.DETAIL_HAPPENED_MESSAGE)
                      : this.props.intl.formatMessage(constants.messages.DETAIL_NOT_HAPPENED_MESSAGE)
                  }
                  secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_HAPPENED_LABEL)}
                />
              </div>

              <div className="col-md-6 col-xs-12">
                { !this.state.prestation.happened
                  ? <ListItem
                    disabled={true}
                    primaryText={
                      this.state.prestation.reason_not_happened
                        ? this.state.prestation.reason_not_happened
                        : undefined
                    }
                    secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_NOT_HAPPENED_REASON_LABEL)}
                  />
                  : undefined
                }
              </div>
            </div>,

            <div
              key={2}
              style={styles.nestedItem}
              className='row'
            >
              <div className="col-md-6 col-xs-12">
                <ListItem
                  disabled={true}
                  primaryText={
                    this.state.prestation.interpreter_travelled
                      ? this.props.intl.formatMessage(constants.messages.DETAIL_INTERPRETER_TRAVELLED_MESSAGE)
                      : this.props.intl.formatMessage(constants.messages.DETAIL_INTERPRETER_NOT_TRAVELLED_MESSAGE)
                  }
                  secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_INTERPRETER_TRAVEL_LABEL)}
                />
              </div>

              <div className="col-md-6 col-xs-12">
                {
                  this.state.prestation.interpreter_delay
                    ? <ListItem
                      disabled={true}
                      primaryText={this.state.prestation.interpreter_delay + ' ' + this.props.intl.formatMessage(constants.messages.MINUTES_LABEL)}
                      secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_INTERPRETER_DELAY_LABEL)}
                    />
                    : undefined
                }
              </div>
            </div>,

            <div
              key={3}
              style={styles.nestedItem}
              className='row'
            >
              <div className="col-md-6 col-xs-12">
                {
                  this.state.prestation.additional_services
                    ? <ListItem
                      disabled={true}
                      primaryText={this.state.prestation.additional_services + ' ' + this.props.intl.formatMessage(constants.messages.MINUTES_LABEL)}
                      secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_ADDITIONAL_SERVICE_LABEL)}
                    />
                    : undefined
                }
              </div>

              <div className="col-md-6 col-xs-12">
                { this.state.prestation.additional_services
                  ? <ListItem
                    disabled={true}
                    primaryText={
                      this.state.prestation.reason_additional_services
                        ? this.state.prestation.reason_additional_services
                        : undefined
                    }
                    secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_ADDITIONAL_SERVICE_REASON_LABEL)}
                  />
                  : undefined
                }
              </div>

              <div className="col-md-6 col-xs-12">
                {
                  this.state.prestation.validation_remarks
                    ? <ListItem
                      disabled={true}
                      primaryText={this.state.prestation.validation_remarks}
                      secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_REMARKS_LABEL)}
                    />
                    : undefined
                }
              </div>
            </div>,

            <div
              key={4}
              style={styles.nestedItem}
              className='row'
            >
              <div className="col-md-7 col-xs-12">
                {
                  this.props.prestation.signature
                    ? <div>
                      {
                        this.props.prestation.signature !== constants.PRESTATION_NO_SIGNATURE
                          ? <GridList
                            cellHeight={200}
                            style={{marginLeft: 1}}
                          >
                            <Subheader style={{fontWeight: 'initial', color: '#0000008a'}}>
                              {this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_SIGNATURE_LABEL)}
                            </Subheader>
                            <GridTile>
                              <img
                                onClick={this.handleDocumentModal}
                                src={this.props.prestation.signature}
                                alt=''
                                style={{cursor: 'pointer'}}
                              />
                            </GridTile>
                          </GridList>
                          : <ListItem
                            disabled={true}
                            primaryText={this.props.intl.formatMessage(constants.messages.VALIDATION_NO_SIGNATURE_LABEL)}
                            secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_SIGNATURE_LABEL)}
                          />
                      }
                    </div>
                    : undefined
                }
              </div>
            </div>
          ]}
        />

        <AlertModal
          open={this.state.showDocument}
          type={AlertModal.CLOSE}
          handleConfirm={this.handleDocumentDialogConfirm}
          contentStyle={{position: 'relative', transform: 0, maxWidth: undefined, width: undefined}}
          bodyStyle={{paddingBottom: 0}}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 0}}
        >
          <img
            style={{width: '100%', maxHeight:windowHeight - 100}}
            src={this.state.document}
            alt=''
          />
        </AlertModal>
      </React.Fragment>
    )
  }
}

const styles = {
  nestedItem: {
    marginLeft: 5,
    wordBreak: 'break-word',
  }
}

export default injectIntl(ValidationInformationPanel)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/ValidationInformationPanel.js